import { Strbuf } from '../types';
import { detectBom } from './detectBom';
import { StringBufAggsHisto } from './getHistoAndBasicAggs.types';
import { guessEncodingNoBom } from './guessEncodingNoBom';
import { DetectedEncoding } from './guessEncodingNoBom.types';

export function guessEncoding(
	buf: Strbuf,
	partialData = false,
	aggs?: StringBufAggsHisto
): [DetectedEncoding, boolean] {
	const enc1 = detectBom(buf);

	if (enc1) {
		return [enc1, true];
	}

	const enc2 = guessEncodingNoBom(aggs ?? buf, partialData);
	return [enc2, false];
}
